import React from 'react';

interface AdminCountersProps {
  totalUserCount: number;
  mobileAppInfo: {
    iosUsers: number;
    androidUsers: number;
  };
}

const AdminCounters: React.FC<AdminCountersProps> = ({
  totalUserCount,
  mobileAppInfo,
}) => {
  return (
    <div
      className="admin-counters"
      style={{
        display: 'flex',
        gap: '1.5rem',
        alignItems: 'baseline',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '.25rem',
          alignItems: 'baseline',
          marginBottom: '1rem',
        }}
      >
        <strong style={{ fontSize: '1.25rem' }}>{totalUserCount}</strong>
        <div className="helper">Total Users</div>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '.25rem',
          alignItems: 'baseline',
          marginBottom: '1rem',
        }}
      >
        <strong style={{ fontSize: '1.25rem' }}>
          {mobileAppInfo?.iosUsers}
        </strong>
        <div className="helper">iOS Users</div>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '.25rem',
          alignItems: 'baseline',
          marginBottom: '1rem',
        }}
      >
        <strong style={{ fontSize: '1.25rem' }}>
          {mobileAppInfo?.androidUsers}
        </strong>
        <div className="helper">Android Users</div>
      </div>
    </div>
  );
};

export default AdminCounters;
